import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function AboutCollege() {
    const facts = [
        { label: 'Established', value: '2013-14' },
        { label: 'NAAC Grade', value: '"B" Grade' },
        { label: 'Managed by', value: 'A.J.M.V.P. Samaj, Ahmednagar' },
        { label: 'Principal', value: 'Dr. Sahadeo Aher (M.Sc., Ph.D.)' },
        { label: 'Location', value: 'Nighoj, Tal. Parner, Dist. Ahmednagar' },
        { label: 'Affiliation', value: 'Savitribai Phule Pune University' },
    ];
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › About Us › About College</p>
                <h1>About College</h1>
                <p>Shri Mulikadevi Mahavidyalaya, Nighoj</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Quick Facts</h2>
                    <table className="data-table">
                        <tbody>
                            {facts.map(f => (
                                <tr key={f.label}>
                                    <td style={{ fontWeight: 700, width: '40%' }}>{f.label}</td>
                                    <td>{f.value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="info-card">
                    <h2>History & Overview</h2>
                    <p>
                        Shri Mulikadevi Mahavidyalaya, Nighoj was established in the academic year 2013-14 by the <strong>Ahmednagar Jilha Maratha Vidya Prasarak Samaj, Ahmednagar</strong>. The college was founded with the primary objective of providing affordable and quality higher education to students from rural and semi-urban backgrounds in the Parner taluka of Ahmednagar district.
                    </p>
                    <p>
                        Since its inception, the college has grown steadily — offering undergraduate programs in Arts, Science, and Computer Science. The institution has been accredited by <strong>NAAC with a "B" Grade</strong>, a testament to its commitment to academic quality and student development.
                    </p>
                    <p>
                        The college is affiliated with <strong>Savitribai Phule Pune University</strong> and follows the University's curriculum. It actively promotes curricular, co-curricular, and extra curricular activities through its numerous committees, NSS unit, sports department, and cultural events.
                    </p>
                </div>
                <div className="info-card">
                    <h2>Principal's Note</h2>
                    <p>
                        <strong>Dr. Sahadeo Aher (M.Sc., Ph.D.)</strong> leads the college with a vision of holistic student development. Under his guidance, the college continues to strengthen its academic programs, improve infrastructure, and foster a culture of inquiry and innovation among students and faculty alike.
                    </p>
                </div>
                <div className="info-card">
                    <h2>Facilities</h2>
                    <div className="cards-grid">
                        {['Well Equipped Building', 'Science Laboratories', 'Computer Lab', 'Library', 'Gymkhana / Sports', 'NSS Unit',].map(f => (
                            <div className="grid-card" key={f}><h3>{f}</h3></div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default AboutCollege;
